import { render } from "./CalendarWithArrowLeftIcon.vue?vue&type=template&id=48a7493a"
import script from "./CalendarWithArrowLeftIcon.vue?vue&type=script&lang=js"
export * from "./CalendarWithArrowLeftIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__